import housingReportGridOptions from './housing-report-grid-options';

/**
 * Class representing the HousingReport Grid.
 */
export default class HousingReportGrid {
    DataPageInstance;
    gridAPI;

    /**
     * Page Options for the grid.
     * @type {Object}
     */
    options = {
        monthly: housingReportGridOptions(this, 'monthly'),
        quarterly: housingReportGridOptions(this, 'quarterly'),
    };

    /**
     * Create a PriceTiersGrid instance.
     * @param {Object} DataPageInstance - The instance of the Data Page.
     */
    constructor(DataPageInstance) {
        this.DataPageInstance = DataPageInstance;

        this.initializeGrid();
    }

    /**
     * Initialize the data grid.
     */
    initializeGrid() {
        const gridContainer = this.DataPageInstance._table_container;
        const activePeriod = this.getActivePeriod();

        this.gridAPI = createGrid(gridContainer, this.options[activePeriod]);
        //
        this.getRows();
    }

    /**
     * Fetch data from the server based on request parameters.
     */
    getRows() {
        this.eventGridRequestStart();
        // clear previous Grid data
        this.gridAPI.setGridOption('rowData', []);

        //
        let request = {};

        request['geoData'] = this.getGeoRequestParams();
        request['tableTypes'] = {
            period: this.getActivePeriod(),
        };
        // console.log(request);

        fetch(
            `${window.location.origin}/wp-json/trerc-data/v1/housing-report-table`,
            {
                method: 'post',
                body: JSON.stringify(request),
                headers: {
                    'Content-Type': 'application/json; charset=utf-8',
                },
            },
        )
            .then((httpResponse) => httpResponse.json())
            .then((response) => {
                let rez = JSON.parse(response);
                // console.log(rez);

                //
                this.gridAPI.setGridOption(
                    'columnDefs',
                    this.options[this.getActivePeriod()].columnDefs,
                );

                // Call the success callback with the parsed response data
                this.gridAPI.setGridOption('rowData', rez.rowData);

                this.eventGridRequestEnd('success', rez);
            })
            .catch((error) => {
                // console.error(error);

                this.eventGridRequestEnd('error', {});
            });
    }

    /**
     * Refresh the data grid.
     */
    refresh() {
        this.getRows();
    }

    /**
     * Get the active period (annual or monthly).
     * @returns {string} - The active period.
     */
    getActivePeriod() {
        return this.DataPageInstance.getActivePeriod();
    }

    /**
     * Get the request parameters for geo data.
     * @returns {Object} - The request parameters.
     */
    getGeoRequestParams() {
        return this.DataPageInstance.getGeoRequestParams();
    }

    /**
     * Dispatch a custom event to signal the start of a grid request.
     */
    eventGridRequestStart() {
        const event = new CustomEvent('gridRequest.Start');
        document.dispatchEvent(event);
    }

    /**
     * Dispatch a custom event to signal the end of a grid request.
     * @param {string} type - The type of the grid request (success or error).
     * @param {Object} data - Data associated with the request.
     */
    eventGridRequestEnd(type, data = {}) {
        const event = new CustomEvent('gridRequest.End', {
            bubbles: true,
            detail: {
                type: type,
                data: data,
            },
        });
        document.dispatchEvent(event);
    }
}
